// extracted by mini-css-extract-plugin
export default {"value":"CapacityResults_value__mWKgD","wrapper":"CapacityResults_wrapper__ciK-D"};